<template>
  <v-footer inset color="white" elevation="3" class="px-0 d-flex justify-center">
    <v-slide-group show-arrows>
      <v-slide-item v-for="(link, key) in links" :key="key">
        <v-btn
          :to="link.path"
          color="black"
          text
          large
          rounded>
          <v-icon left>{{ link.icon }}</v-icon>
          {{ $t(`navigation.${link.title.toLowerCase()}`) }}
        </v-btn>
      </v-slide-item>
    </v-slide-group>
  </v-footer>
</template>

<script>
import { pathTo } from '@/plugins/router/helper';

export default {
  name: 'Footer',
  data: () => ({
    links: [
      {
        title: 'Home',
        icon: 'home',
        path: pathTo.home,
      },
      {
        title: 'Learn',
        icon: 'school',
        path: pathTo.learn,
      },
      {
        title: 'MyVocabulary',
        icon: 'view_list',
        path: pathTo.my_vocabulary,
      },
    ],
  }),
};
</script>
